(function($, undefined) {
	
	'use strict';
	var form;
	var showBioBtn;
	var bioCtn;
	var bio;

	var showAllBio = function() {
		bioCtn.height(bio.height());
		bioCtn.addClass('open');
		showBioBtn.slideUp();

		setTimeout(function() {
			bioCtn.height('auto');
		}, 300);
	};

	var linkToAgency = function() {
		var t = $(this);
		var id = t.attr('data-id');
		
		$.ajax({
			url: '/action/vcManageInvitations',
			cache: false,
			data: {
				personId: id
			},
			success: function (response) {
				console.log('agency : ' + response);
				
				if (response === 'fail wrong type account') {
					form.showErrorPopupAnimation('agency-link-error');
				} else if (response === 'already-in-process') {
					form.showErrorPopupAnimation('agency-already-in-progress');
				} else if (response === 'already-linked') {
					form.showErrorPopupAnimation('agency-already-linked');
				} else {
					form.showErrorPopupAnimation('agency-link-success');
					
					$('.account-agency-pending').slideDown(200);
				}
			}
		});
	};

	var scrollToBottomCtn = function() {
		var target = $('.profile-bottom-ctn').offset().top - $('.site-header').height();

		$('html').animate({scrollTop: target});
		$('body').animate({scrollTop: target});
	};

	var checkBioLength = function() {
		if (bio.height() > bioCtn.height()) {
			showBioBtn.slideDown();
			showBioBtn.click(showAllBio);
		} else {
			bioCtn.addClass('open');
		}
	};

	var countContactClick = function() {
		var t = $(this);
		var id = t.attr('data-personid');

		t.slideUp(function() {
			$(this).remove();
		});
		
		$.ajax({
			url: '/action/vcUpdateCounter',
			cache: false,
			data: {
				contact: true,
				personId: id,
				ajax: true
			},
			success: function (response) {
				//console.log('contact click count : ' + response);
			}
		});

	};
	
	var init = function () {
		form = Fw.component.models().form;
		bioCtn = $('.profile-bio-tab-inner-ctn');
		showBioBtn = $('.bio-learn-more-btn');
		bio = $('.profile-bio');

		$('.add-artist-to-agency-btn').click(linkToAgency);
		$('.scroll-to-demos-btn').click(scrollToBottomCtn);
		$('.count-contact-click-btn').click(countContactClick);
		checkBioLength();
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
